<template>
  <div class="terms_page">
    <p>1. 개인정보처리의 위탁에 관한 사항</p>
    <p>(1) 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
    <table border="1" height="175" width="100%">
      <tbody>
        <tr bgcolor="#d3d3d3">
          <td style="width: 22.2%">&nbsp;수탁업체</td>
          <td style="width: 77.6%">&nbsp;위탁업무</td>
        </tr>
        <tr>
          <td style="width: 22.2%">&nbsp;카페24(주)</td>
          <td style="width: 77.6%">&nbsp;쇼핑몰 호스팅 서비스의 시스템 제공 및 유지∙보수</td>
        </tr>
        <tr>
          <td style="width: 22.2%">&nbsp;CJ택배</td>
          <td style="width: 77.6%">&nbsp;물품 배송 및 수거 업무&nbsp;</td>
        </tr>
        <tr>
          <td style="width: 22.2%">&nbsp;이니시스</td>
          <td style="width: 77.6%">&nbsp;구매 및 요금 결제 대행 (인터넷 쇼핑몰)</td>
        </tr>
        <tr>
          <td style="width: 22.2%">&nbsp;비잼</td>
          <td style="width: 77.6%">&nbsp;인터넷 쇼핑몰 이용 서비스(인터넷 위탁 쇼핑몰)</td>
        </tr>
      </tbody>
    </table>
    <p>(2) 회사는 위탁계약 체결시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
    <p>(3) 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</p>
  </div>
</template>
<style scoped>
.terms_page {
  background: white;
  padding: 20px;
  font-size: 14px;
  height: calc(100% - 48px);
  overflow: auto;
  letter-spacing: -1.2px;
}
</style>
